export class ShortcutListener {
  private activeKeys: Key[] = [];

  constructor(private shortcutsMap: Array<{ shortcut: Key[]; listener: Listener }> = []) {
    window.addEventListener("keydown", this.handleKeydown);
    window.addEventListener("keyup", this.handleKeyup);
  }

  on(shortcut: Key[], listener: Listener) {
    this.shortcutsMap.push({ shortcut, listener });
  }

  private handleKeydown = (e: KeyboardEvent) => {
    if (!e.repeat) {
      this.activeKeys.push(e.key);

      this.runListeners();
    }
  };

  private handleKeyup = (e: KeyboardEvent) => {
    this.activeKeys = this.activeKeys.filter(key => key !== e.key);
  };

  private runListeners() {
    this.shortcutsMap
      .filter(({ shortcut }) => compareArray(shortcut, this.activeKeys))
      .forEach(({ listener }) => listener());
  }
}

type Key = string;
type Listener = () => void;

function compareArray(a: Key[], b: Key[]) {
  return a.every(key => b.includes(key)) && b.every(key => a.includes(key));
}
